import type { SolutionId } from '../types/platform'

/**
 * MCP waitlist submission endpoint (POST, JSON).
 *
 * PRODUCTION INTEGRATION REQUIRED — this site has no signup/CRM integration yet,
 * so this is empty and the form shows an "unavailable" error instead of a fake
 * success. Point it at your CRM webhook or signup API. Expected contract:
 *   Request:  { email, workflow, goal, tag: "MCP waitlist", sourcePage }
 *   201/200:  saved → success message
 *   409, or { status: "already_registered" } → repeat-signup message
 *   anything else → error message
 */
export const MCP_WAITLIST_ENDPOINT = ''

/** Tag applied to every submission so the CRM can segment it. */
export const MCP_WAITLIST_TAG = 'MCP waitlist'

export const MCP_WAITLIST_PATH = '/mcp#waitlist'

export const MCP_WORKFLOW_OPTIONS: { value: SolutionId | 'other'; label: string }[] = [
  { value: 'invest', label: 'Invest' },
  { value: 'buy', label: 'Buy' },
  { value: 'acquire', label: 'Acquire' },
  { value: 'select', label: 'Select' },
  { value: 'assure', label: 'Assure' },
  { value: 'monitor', label: 'Monitor' },
  { value: 'other', label: 'Other' },
]

/** Illustrative example: how an investment team could chain agents over MCP. */
export const MCP_EXAMPLE_STEPS = [
  { agent: 'Thesis Fit Agent', action: 'Screen the submission', result: 'Fits 4 of 5 thesis criteria' },
  { agent: 'Gap Analysis Agent', action: 'Identify missing evidence', result: 'No customer revenue breakdown; no cap table' },
  { agent: 'Investment Memo Agent', action: 'Prepare a draft memo', result: 'Draft memo ready for analyst review' },
] as const

export const MCP_SUCCESS_MESSAGE = 'You’re on the MCP access waitlist. We’ll email you when access is available.'
